import { EDIT_WPARTICLES } from '../action-types';

const initialState = {
  articles: [],
};

const wpArticles = (state = initialState, action) => {
  switch (action.type) {
    case EDIT_WPARTICLES:
      return { articles: action.articles };
    default:
      return { ...state };
  }
};

export default wpArticles;
